import React, { useEffect, useRef, useState } from "react";
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import InputMask from 'react-input-mask';

import styles from './index.module.css';

import showIcon from '../../assets/icons/misc/password_show.svg';
import hideIcon from '../../assets/icons/misc/password_hide.svg';

let inputList;

function Input(props) {
  const { error, focus, id, value, onChange, type, focusList, className, showHide, tvMode, alphaNumeric } = props;
  
  const [passShow, setPassShow] = useState(false);
  const focusListRef = useRef(focusList);
  const setFocusList = (data) => {
    focusListRef.current = data;
  }

  const newProps = Object.assign({}, props);
  delete newProps.id;
  delete newProps.showHide;
  delete newProps.tvMode;

  let crystalEffect = true;

  if (tvMode || type === 'otp' || type === 'pin') {
    crystalEffect = false;
  }

  useEffect(() => {
    if (!tvMode) {
      if (type === 'otp' || type === 'pin') {
        inputList = document.getElementById(id).getElementsByTagName('input');
        inputList[0].focus();
      }
    } else {
      if (focus) {
        inputList = document.getElementById(id).getElementsByTagName('input');
        document.addEventListener('keydown', keyPress);
      } else {
        document.removeEventListener('keydown', keyPress);

        if (id) {
          document.getElementById(id).children[0].blur();
        }
      }
    }

    return () => {
      document.removeEventListener('keydown', keyPress);
    }
  /* eslint-disable */
  }, [focus]);

  useEffect(() => {
    if (error && !tvMode) {
      if (type === 'otp' || type === 'pin') {
        inputList[0].focus();
      }
    }
  }, [error]);

  useEffect(() => {
    setFocusList(focusList);
  }, [focusList]);

  const keyPress = (e) => {
    if (e.keyCode === 13) { // ENTER KEY
      if (type === 'otp' || type === 'pin') {
        inputList[focusListRef.current.indexOf(true)].focus();
      } else {
        inputList[0].focus();
      }
    }
  }

  const onKeyDown = (e, index) => {
    if (props.onKeyDown) {
      props.onKeyDown(e, index);
    }
  }

  const lastKeyUp = (e) => {
    if (props.onKeyUp) {
      props.onKeyUp(e);
    }
  }

  if (type === 'password') {
    if (passShow) {
      newProps.type = 'text';
    }
  }

  return (
    <div id={id} className={`${styles['input-container']} ${ focus ? styles['focused'] : "" } ${ crystalEffect ? styles['crystal'] : "" } ${ className ? className : "" }`}>
      {
        type === 'mobile' ?
          <InputMask
            {...newProps}
            mask='9999 9999'
            maskChar=""
            className={`${styles['input']} ${ error ? styles['highlight-red'] : "" }`}
            type="tel"
          />
          :
          type === 'otp' ?
            <div className={styles['row']}>
              <div className={`${styles['col']} ${ focus && focusList[0] ? styles['focused'] : "" }`}>
                <input className={`${styles['otp-input']} ${ error ? styles['highlight-red'] : "" }`} value={value[0]} type={ alphaNumeric ? "text" : "tel" } onChange={(e) => onChange(e, 0)} required />
              </div>
              <div className={`${styles['col']} ${ focus && focusList[1] ? styles['focused'] : "" }`}>
                <input className={`${styles['otp-input']} ${ error ? styles['highlight-red'] : "" }`} value={value[1]} type={ alphaNumeric ? "text" : "tel" } onChange={(e) => onChange(e, 1)} onKeyDown={(e) => onKeyDown(e, 1)} required />
              </div>
              <div className={`${styles['col']} ${ focus && focusList[2] ? styles['focused'] : "" }`}>
                <input className={`${styles['otp-input']} ${ error ? styles['highlight-red'] : "" }`} value={value[2]} type={ alphaNumeric ? "text" : "tel" } onChange={(e) => onChange(e, 2)} onKeyDown={(e) => onKeyDown(e, 2)} required />
              </div> 
              <div className={`${styles['col']} ${ focus && focusList[3] ? styles['focused'] : "" }`}>
                <input className={`${styles['otp-input']} ${ error ? styles['highlight-red'] : "" }`} value={value[3]} type={ alphaNumeric ? "text" : "tel" } onChange={(e) => onChange(e, 3)} onKeyDown={(e) => onKeyDown(e, 3)} required />
              </div>
              <div className={`${styles['col']} ${ focus && focusList[4] ? styles['focused'] : "" }`}>
                <input className={`${styles['otp-input']} ${ error ? styles['highlight-red'] : "" }`} value={value[4]} type={ alphaNumeric ? "text" : "tel" } onChange={(e) => onChange(e, 4)} onKeyDown={(e) => onKeyDown(e, 4)} required />
              </div>
              <div className={`${styles['col']} ${ focus && focusList[5] ? styles['focused'] : "" }`}>
                <input className={`${styles['otp-input']} ${ error ? styles['highlight-red'] : "" }`} value={value[5]} type={ alphaNumeric ? "text" : "tel" } onChange={(e) => onChange(e, 5)} onKeyDown={(e) => onKeyDown(e, 5)} onKeyUp={lastKeyUp} required />
              </div>
            </div>
            :
            type === 'pin' ?
              <div className={`${styles['row']} ${styles['pin']}`}>
                <div className={`${styles['col']} ${ focus && focusList[0] ? styles['focused'] : "" }`}>
                  <input className={`${styles['otp-input']} ${ error ? styles['highlight-red'] : "" }`} value={value[0]} type={ alphaNumeric ? "text" : "tel" } onChange={(e) => onChange(e, 0)} required />
                </div>
                <div className={`${styles['col']} ${ focus && focusList[1] ? styles['focused'] : "" }`}>
                  <input className={`${styles['otp-input']} ${ error ? styles['highlight-red'] : "" }`} value={value[1]} type={ alphaNumeric ? "text" : "tel" } onChange={(e) => onChange(e, 1)} onKeyDown={(e) => onKeyDown(e, 1)} required />
                </div>
                <div className={`${styles['col']} ${ focus && focusList[2] ? styles['focused'] : "" }`}>
                  <input className={`${styles['otp-input']} ${ error ? styles['highlight-red'] : "" }`} value={value[2]} type={ alphaNumeric ? "text" : "tel" } onChange={(e) => onChange(e, 2)} onKeyDown={(e) => onKeyDown(e, 2)} required />
                </div> 
                <div className={`${styles['col']} ${ focus && focusList[3] ? styles['focused'] : "" }`}>
                  <input className={`${styles['otp-input']} ${ error ? styles['highlight-red'] : "" }`} value={value[3]} type={ alphaNumeric ? "text" : "tel" } onChange={(e) => onChange(e, 3)} onKeyDown={(e) => onKeyDown(e, 3)} onKeyUp={lastKeyUp} required />
                </div>
              </div>
              :
              <input
                {...newProps}
                className={`${styles['input']} ${ error ? styles['highlight-red'] : "" }`}
              />
      }
      
      {
        showHide ?
          <div className={styles['input-icon']} onClick={() => setPassShow(!passShow)}>
            {
              passShow ?
                <img src={showIcon} alt="pass-show" />
                :
                <img src={hideIcon} alt="pass-hide" />
            }
          </div>
          :
          ""
      }
      
    </div>
  );
}

const mapStateToProps = state => ({
  tvMode: state.app.tvMode
});

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(Input);
